module.exports = __webpack_public_path__ + "static/arkAVR-caedb487eec34261dac8956bd8c4c85b.webp";